import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

// import view components
import HomePage from "@/components/HomePage.vue";

// import static components
import Barrierefreiheit from "@/views/static/Barrierefreiheit.vue";
import Masthead from "@/views/static/Masthead.vue";
import Privacy from "@/views/static/Privacy.vue";
import ErrorPage from "@/components/ErrorPage.vue";

// routing instructions
const router = new Router({
  mode: "hash",
  base: "/nondobs/client/",
  routes: [
    {
      // default starting page
      path: "/",
      name: "home",
      component: HomePage,
    },
    {
      path: "/p:pageNumber",
      name: "home-pageNumber",
      component: HomePage,
      props: true,
    },
    {
      // masthead component
      path: "/impressum",
      name: "impressum",
      component: Masthead,
    },
    {
      // privacy information text component
      path: "/datenschutz",
      name: "datenschutz",
      component: Privacy,
    },
    {
      // Accessibility declaration information text component
      path: "/barrierefreiheit",
      name: "barrierefreiheit",
      component: Barrierefreiheit,
    },
    {
      path: "/error",
      name: "errorpage",
      component: ErrorPage,
    },
    {
      path: "*",
      redirect: {
        name: "errorpage",
      },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
